import { cloneElement } from 'react';
import { ResponsiveWrapper } from '@/components';
import { ContentDimensions } from '@/core';

export interface ResponsivePanelWrapperProps extends Partial<ContentDimensions> {
  children: React.ReactElement | ((dimensions: ContentDimensions) => React.ReactNode);
}

/**
 * Wrapper component used for context-aware data visualizations to manage choosing between using the content dimensions
 * as is (when provided) or falling back to a responsive wrapper.
 */
export const ResponsivePanelWrapper = ({ children, width, height }: ResponsivePanelWrapperProps) => {
  const shouldUseResponsiveWrapper = typeof width === 'undefined' || typeof height === 'undefined';

  // Use a responsive wrapper to get dimensions when we do not have all of them defined.
  if (shouldUseResponsiveWrapper) {
    return (
      <ResponsiveWrapper width={width} height={height}>
        {children}
      </ResponsiveWrapper>
    );
  }

  // If dimensions are provided, a `ResponsiveWrapper` is not needed (and adds unnecessary overhead). Pass along the
  // dimensions to the component.
  if (typeof children === 'function') {
    return children({ height, width });
  }
  return cloneElement(children, { height, width });
};
